module.exports = __webpack_public_path__ + "img/close.d6fa4d45.svg";